import React, { useState, useEffect } from 'react';
import './MyProfile.scss';
import PagesNavBar from './PagesNavBar';
import { useParams } from 'react-router-dom';
import { CheckPermissionsToViewProducer } from '../../api/admin';
import { useUser } from '../../context/UserContext';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';

function Index() {
  const params = useParams();
  const location = useLocation();
  const prevLocation = location.state?.prevLocation;
  const [producerID, setProducerID] = useState('');
  const user = useUser();
  const [unauthorizedAccessMsg, setUnAuthorizedAccessMessage] = useState('');

  function hasProducerID() {
    return producerID !== null && producerID !== '' && producerID !== undefined;
  }

  useEffect(() => {
    var wildCard = params['*'];
    var routeArray = wildCard.split('/');

    if (routeArray.length > 1) setProducerID(routeArray[1]);
  }, [params]);

  const checkPermissionsToViewProducer = useQuery({
    queryKey: ['CheckPermissionsToViewProducer', producerID],
    queryFn: () => CheckPermissionsToViewProducer({ ProducerID: producerID })(),
    enabled:
      user != null &&
      user.isHO === false &&
      hasProducerID() &&
      (user.userType === 'IMO' || user.userType === 'SUB-IMO'),
  });

  useEffect(() => {
    if (checkPermissionsToViewProducer.isSuccess && checkPermissionsToViewProducer.data) {
      var jsonData = JSON.parse(checkPermissionsToViewProducer.data);

      if (jsonData === '{}') {
        setUnAuthorizedAccessMessage("You don't have access to Producer ID: " + producerID);
        return;
      }

      if (jsonData.HasPermission === false) {
        setUnAuthorizedAccessMessage("You don't have access to Producer ID: " + producerID);
      }
    }
  }, [checkPermissionsToViewProducer.isSuccess, checkPermissionsToViewProducer.data, producerID]);

  if (user.userType !== 'IMO' && user.userType !== 'SUB-IMO' && hasProducerID()) {
    //not IMO with Producer ID
    return <Navigate to="/MyProfile/Demographic" />; //redirect to home page
  }

  if (unauthorizedAccessMsg.length > 0) {
    //don't have access to Producer ID
    return <div style={{ textAlign: 'center', fontSize: 'larger' }}>{unauthorizedAccessMsg}</div>;
  }

  return (
    <div>
      <PagesNavBar producerID={producerID} prevLocation={prevLocation} />
    </div>
  );
}

export { Index };
